<template>
    <el-form :model="formInfo"
             ref="formInfo"
             size="small"
             :rules="$options.rules"
             :show-message="false"
             hide-required-asterisk
    >
        <el-form-item class="form-item">
            <div id="name-number-item">
                <el-form-item class="form-item-inner" prop="name">
                    <el-input v-model="formInfo.name"
                              @change="$store.commit('SET_VIEWER_TAB_TITLE', formInfo.name)"
                              placeholder="Name"
                              ref="name">
                    </el-input>
                </el-form-item>
                <el-form-item class="form-item-inner" prop="number">
                    <el-input v-model="formInfo.number" placeholder="Number"/>
                </el-form-item>
            </div>
        </el-form-item>
        <el-form-item class="form-item" prop="description">
            <el-input v-model="formInfo.description" placeholder="Description" type="textarea" :rows="1"/>
        </el-form-item>
    </el-form>
</template>

<script>
  export default {
    name: "ModelerInfo",

    props: {
      formInfo: Object,
    },

    // STATIC DATA
    rules: {
      name: [{required: true, message: 'Name is required', trigger: ['change']}]
    },

    mounted() {
      this.$nextTick(() => {
        // initialize cursor focus, allowing time for parent to load
        setTimeout(function () {
          this.$refs.name.focus();
        }.bind(this), 20);
      })
    },

    methods: {
      validate() {
        return this.$refs.formInfo.validate()
      },
    },
  }
</script>

<style scoped src="../../assets/css/form.css"/>
<style scoped lang="scss">
    #name-number-item {
        display: grid;
        grid-template-columns: .64fr .36fr;
        grid-column-gap: 1em;
    }
</style>
